import HttpClient from './core.service'
const { get } = HttpClient

export const getLostDog = (payload: any) => get('/admin/lost_dog', payload)
export const getNotification = (id: any) => get('/admin/lost_dog/detail/' + id)